module.exports = __webpack_public_path__ + "img/jenkins.72e571ed.png";